"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1433],{

/***/ 20970:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": function() { return /* binding */ ToggleInput; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _libs_useTheme__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5779);
/* harmony import */ var _components_base_Box__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(51773);




/**
 * Primary UI component for toggle input
 */ const ToggleInput = (param)=>{
    let { label , placeholder , onChange , className , hint , required , value , options , selected =0 , callback , centerText =false , show =true , error  } = param;
    const errorMessage = error;
    const hiddenFileInput = react__WEBPACK_IMPORTED_MODULE_1__.useRef(null);
    const [toggleValue, setToggleValue] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(selected !== null && selected !== void 0 ? selected : 0);
    const { theme  } = (0,_libs_useTheme__WEBPACK_IMPORTED_MODULE_2__/* .useTheme */ .Fg)();
    const isLight = theme.type === "LIGHT";
    if (!show) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
        htmlFor: "formToggle",
        className: [
            "flex flex-col text-sm space-y-1 text-white",
            className
        ].join(" "),
        children: [
            (errorMessage || label || hint) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                className: "transition-all ".concat(required ? "pl-2" : "px-2", " ").concat(errorMessage ? "text-red-500" : isLight ? "text-black" : "text-white"),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                        className: "z-10 ".concat(required ? "after:content-['*'] after:mx-2 after:text-red-500" : ""),
                        children: [
                            errorMessage !== null && errorMessage !== void 0 ? errorMessage : label,
                            " "
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "\n        ".concat(isLight ? "text-black" : "text-white", " \n        ml-2 text-xs\n        "),
                        children: hint
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_Box__WEBPACK_IMPORTED_MODULE_3__["default"], {
                className: "flex w-full",
                children: options.map((c, index)=>{
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_Box__WEBPACK_IMPORTED_MODULE_3__["default"], {
                        className: "\n                py-1 flex justify-center items-center h-[55px] break-keep text-nowrap\n                ".concat(selected === index && "bg-forumm-blue-light-2", "\n                ").concat(index + 1 === options.length && "rounded-r-2xl", "\n                ").concat(index === 0 && "rounded-l-2xl", "\n                ").concat(centerText && "text-center", "\n                ").concat(isLight ? "border-forumm-gray-3" : "border-white", "\n                border py-2 px-3 cursor-pointer flex-1\n                ").concat(selected === index && "!text-[#181A20]", "\n              "),
                        onClick: async ()=>{
                            hiddenFileInput.current.value = c;
                            if (callback) return callback(c);
                        },
                        children: selected === index ? "✓  ".concat(c) : c
                    }, index);
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                required: required,
                className: "hidden",
                type: "text",
                id: label,
                ref: hiddenFileInput,
                onChange: (e)=>{
                    if (onChange) onChange(e);
                },
                value: options[selected]
            })
        ]
    });
};


/***/ }),

/***/ 30530:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

const currencies = {
    CAD: {
        symbol: "$",
        name: "Canadian Dollar"
    },
    USD: {
        symbol: "$",
        name: "US Dollar"
    },
    EUR: {
        symbol: "€",
        name: "Euro"
    },
    GBP: {
        symbol: "\xa3",
        name: "British Pound"
    }
};
/* harmony default export */ __webpack_exports__["Z"] = (currencies);


/***/ }),

/***/ 61433:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_base_Box__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51773);
/* harmony import */ var _components_inputs_Button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11390);
/* harmony import */ var _components_inputs_DropdownInput__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61993);
/* harmony import */ var _components_inputs_PriceInput__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(84456);
/* harmony import */ var _components_inputs_TextInput__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(39618);
/* harmony import */ var _components_base_Modal__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(18860);
/* harmony import */ var _graphql_generated_graphql__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(68240);
/* harmony import */ var _layouts_CreateEventLayout__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(67526);
/* harmony import */ var _libs_CreateEvent_useEventEditor__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(25687);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(67294);
/* harmony import */ var _components_base_Table__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(45672);
/* harmony import */ var _components_event_TableRowActions__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(29033);
/* harmony import */ var _libs_currencies__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(30530);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var _registrationFields__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(60899);
/* harmony import */ var _discounts__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(14904);
/* harmony import */ var _components_inputs_ToggleInput__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(20970);


















const TicketsForm = (param)=>{
    let { currency  } = param;
    const [showTicketModal, setShowTicketModal] = (0,react__WEBPACK_IMPORTED_MODULE_10__.useState)(false);
    const [showFieldModal, setShowFieldModal] = (0,react__WEBPACK_IMPORTED_MODULE_10__.useState)(false);
    const [showDiscountModal, setShowDiscountModal] = (0,react__WEBPACK_IMPORTED_MODULE_10__.useState)(false);
    const [showLinkModal, setShowLinkModal] = (0,react__WEBPACK_IMPORTED_MODULE_10__.useState)(false);
    const { formData , setFormData , stripePaymentsReady , stripeStatusLoading  } = (0,_libs_CreateEvent_useEventEditor__WEBPACK_IMPORTED_MODULE_9__/* .useEventEditor */ .O)();
    const currencyDetails = _libs_currencies__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z[currency.toUpperCase()];
    const [ticketModalData, setTicketModalData] = (0,react__WEBPACK_IMPORTED_MODULE_10__.useState)(undefined);
    const [discountModalData, setDiscountModalData] = (0,react__WEBPACK_IMPORTED_MODULE_10__.useState)(undefined);
    const [fieldModalData, setFieldModalData] = (0,react__WEBPACK_IMPORTED_MODULE_10__.useState)(undefined);
    const { registrationFields  } = formData !== null && formData !== void 0 ? formData : {};
    const tickets = (0,react__WEBPACK_IMPORTED_MODULE_10__.useMemo)(()=>{
        var ref;
        const payload = [];
        formData === null || formData === void 0 ? void 0 : (ref = formData.tickets) === null || ref === void 0 ? void 0 : ref.forEach((t)=>{
            var ref, ref1;
            const availableTicket = (ref = formData.availableTickets) === null || ref === void 0 ? void 0 : (ref1 = ref.tickets) === null || ref1 === void 0 ? void 0 : ref1.find((at)=>at.ticketTitle === t.title);
            payload.push({
                ...t,
                remaining: (availableTicket === null || availableTicket === void 0 ? void 0 : availableTicket.remaining) ? (0,lodash__WEBPACK_IMPORTED_MODULE_14__.parseInt)(availableTicket === null || availableTicket === void 0 ? void 0 : availableTicket.remaining) : 0
            });
        });
        return payload;
    }, [
        formData === null || formData === void 0 ? void 0 : formData.tickets,
        formData === null || formData === void 0 ? void 0 : formData.availableTickets
    ]);
    const discounts = (0,react__WEBPACK_IMPORTED_MODULE_10__.useMemo)(()=>{
        var ref;
        const payload = [];
        formData === null || formData === void 0 ? void 0 : (ref = formData.discounts) === null || ref === void 0 ? void 0 : ref.forEach((dc)=>{
            var ref, ref1, ref2;
            const availableTicket = (ref = formData.availableTickets) === null || ref === void 0 ? void 0 : (ref1 = ref.tickets) === null || ref1 === void 0 ? void 0 : ref1.find((at)=>{
                var ref;
                return (ref = at.discountCodes) === null || ref === void 0 ? void 0 : ref.map((c)=>c.title).includes(dc.title);
            });
            const discount = availableTicket === null || availableTicket === void 0 ? void 0 : (ref2 = availableTicket.discountCodes) === null || ref2 === void 0 ? void 0 : ref2.find((f)=>f.title.toUpperCase() === dc.title.toUpperCase());
            var ref3, ref4;
            payload.push({
                ...dc,
                remaining: (ref4 = discount === null || discount === void 0 ? void 0 : discount.remaining) !== null && ref4 !== void 0 ? ref4 : (0,lodash__WEBPACK_IMPORTED_MODULE_14__.parseInt)((ref3 = availableTicket === null || availableTicket === void 0 ? void 0 : availableTicket.remaining) !== null && ref3 !== void 0 ? ref3 : "0")
            });
        });
        return payload;
    }, [
        formData === null || formData === void 0 ? void 0 : formData.discounts,
        formData === null || formData === void 0 ? void 0 : formData.availableTickets
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_10__.useEffect)(()=>{
        var ref;
        const payload = {
            ...formData,
            event: {
                ...formData === null || formData === void 0 ? void 0 : formData.event,
                currency: currency
            }
        };
        if ((formData === null || formData === void 0 ? void 0 : (ref = formData.event) === null || ref === void 0 ? void 0 : ref.currency) !== currency) setFormData(payload);
    // eslint-disable-next-line
    }, [
        currency
    ]);
    const noTickets = tickets == undefined || tickets.length === 0;
    const hasPaidTickets = tickets.some((ticket)=>ticket.ticketType === _graphql_generated_graphql__WEBPACK_IMPORTED_MODULE_7__/* .TicketType.Paid */ .zK.Paid);
    const noFields = registrationFields == undefined || registrationFields.length === 0;
    const noDiscounts = discounts == undefined || discounts.length === 0;
    const addTicketModal = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_base_Modal__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
        show: showTicketModal,
        setShow: setShowTicketModal,
        title: "".concat((ticketModalData === null || ticketModalData === void 0 ? void 0 : ticketModalData.editIndex) !== undefined || (ticketModalData === null || ticketModalData === void 0 ? void 0 : ticketModalData.editIndex) === 0 ? "Edit" : "Create", " Ticket"),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_inputs_TextInput__WEBPACK_IMPORTED_MODULE_5__/* .TextInput */ .o, {
                validations: {
                    minLength: {
                        value: 1,
                        message: "Ticket name must be at least 1 character"
                    },
                    maxLength: {
                        value: 70,
                        message: "Ticket name must be at most 70 characters"
                    }
                },
                required: true,
                label: "Title",
                placeholder: "VIP Ticket",
                value: ticketModalData === null || ticketModalData === void 0 ? void 0 : ticketModalData.title,
                onChange: (data)=>{
                    setTicketModalData({
                        ...ticketModalData,
                        title: data
                    });
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_inputs_TextInput__WEBPACK_IMPORTED_MODULE_5__/* .TextInput */ .o, {
                required: true,
                label: "Available Tickets",
                placeholder: "50",
                type: "number",
                value: ticketModalData === null || ticketModalData === void 0 ? void 0 : ticketModalData.quantity,
                validations: {
                    minLength: {
                        value: 1,
                        message: "Tickets available must be at least 1 "
                    },
                    maxLength: {
                        value: 4,
                        message: "Tickets available must be at most 9999"
                    }
                },
                onChange: (data)=>{
                    setTicketModalData({
                        ...ticketModalData,
                        quantity: data
                    });
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_inputs_DropdownInput__WEBPACK_IMPORTED_MODULE_3__/* .DropdownInput */ .f, {
                label: "Ticket Type",
                options: [
                    {
                        value: _graphql_generated_graphql__WEBPACK_IMPORTED_MODULE_7__/* .TicketType.Paid */ .zK.Paid,
                        label: "Paid"
                    },
                    {
                        value: _graphql_generated_graphql__WEBPACK_IMPORTED_MODULE_7__/* .TicketType.Free */ .zK.Free,
                        label: "Free"
                    },
                    {
                        value: _graphql_generated_graphql__WEBPACK_IMPORTED_MODULE_7__/* .TicketType.InvoiceTicket */ .zK.InvoiceTicket,
                        label: "Invoice Ticket"
                    },
                    {
                        value: _graphql_generated_graphql__WEBPACK_IMPORTED_MODULE_7__/* .TicketType.WaitingList */ .zK.WaitingList,
                        label: "Waiting List"
                    }
                ],
                required: true,
                placeholder: "Select a ticket type",
                onChange: (data)=>{
                    setTicketModalData({
                        ...ticketModalData,
                        ticketType: data
                    });
                },
                value: ticketModalData === null || ticketModalData === void 0 ? void 0 : ticketModalData.ticketType
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_Box__WEBPACK_IMPORTED_MODULE_1__["default"], {
                show: (ticketModalData === null || ticketModalData === void 0 ? void 0 : ticketModalData.ticketType) === _graphql_generated_graphql__WEBPACK_IMPORTED_MODULE_7__/* .TicketType.Paid */ .zK.Paid || (ticketModalData === null || ticketModalData === void 0 ? void 0 : ticketModalData.ticketType) === _graphql_generated_graphql__WEBPACK_IMPORTED_MODULE_7__/* .TicketType.InvoiceTicket */ .zK.InvoiceTicket,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_inputs_PriceInput__WEBPACK_IMPORTED_MODULE_4__/* .PriceInput */ .t, {
                    required: true,
                    label: "Price",
                    currencySymbol: currencyDetails.symbol,
                    value: ticketModalData === null || ticketModalData === void 0 ? void 0 : ticketModalData.price,
                    onChange: (data)=>{
                        setTicketModalData({
                            ...ticketModalData,
                            price: data
                        });
                    },
                    placeholder: "14.99"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_inputs_ToggleInput__WEBPACK_IMPORTED_MODULE_17__/* .ToggleInput */ .s, {
                errorMessage: undefined,
                selected: (ticketModalData === null || ticketModalData === void 0 ? void 0 : ticketModalData.allowMultiplePurchase) ? 0 : 1,
                centerText: true,
                options: [
                    "Yes",
                    "No"
                ],
                className: "mb-4",
                value: (ticketModalData === null || ticketModalData === void 0 ? void 0 : ticketModalData.allowMultiplePurchase) ? "Yes" : "No",
                callback: (val)=>{
                    setTicketModalData({
                        ...ticketModalData,
                        allowMultiplePurchase: val === "Yes" ? true : false
                    });
                },
                label: "Allow users to purchase multiple tickets"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_Box__WEBPACK_IMPORTED_MODULE_1__["default"], {
                className: "flex justify-between items-center w-full",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_inputs_Button__WEBPACK_IMPORTED_MODULE_2__/* .Button */ .z, {
                    className: "my-4 ml-auto",
                    title: "".concat((ticketModalData === null || ticketModalData === void 0 ? void 0 : ticketModalData.editIndex) !== undefined || (ticketModalData === null || ticketModalData === void 0 ? void 0 : ticketModalData.editIndex) === 0 ? "Edit Ticket" : "Create Ticket"),
                    type: "primary",
                    onClick: (e)=>{
                        var ref, ref1;
                        e.preventDefault();
                        console.log({
                            S: ticketModalData
                        });
                        var ref2, ref3, ref4, ref5, ref6;
                        const ticketData = {
                            title: (ref2 = ticketModalData === null || ticketModalData === void 0 ? void 0 : ticketModalData.title) !== null && ref2 !== void 0 ? ref2 : "",
                            ticketType: (ref3 = ticketModalData === null || ticketModalData === void 0 ? void 0 : ticketModalData.ticketType) !== null && ref3 !== void 0 ? ref3 : _graphql_generated_graphql__WEBPACK_IMPORTED_MODULE_7__/* .TicketType.Free */ .zK.Free,
                            price: (ticketModalData === null || ticketModalData === void 0 ? void 0 : ticketModalData.ticketType) === _graphql_generated_graphql__WEBPACK_IMPORTED_MODULE_7__/* .TicketType.Paid */ .zK.Paid || (ticketModalData === null || ticketModalData === void 0 ? void 0 : ticketModalData.ticketType) === _graphql_generated_graphql__WEBPACK_IMPORTED_MODULE_7__/* .TicketType.InvoiceTicket */ .zK.InvoiceTicket ? parseFloat((ref4 = ticketModalData === null || ticketModalData === void 0 ? void 0 : (ref = ticketModalData.price) === null || ref === void 0 ? void 0 : ref.toString()) !== null && ref4 !== void 0 ? ref4 : "0.00") : 0,
                            quantity: (0,lodash__WEBPACK_IMPORTED_MODULE_14__.parseInt)((ref5 = ticketModalData === null || ticketModalData === void 0 ? void 0 : (ref1 = ticketModalData.quantity) === null || ref1 === void 0 ? void 0 : ref1.toString()) !== null && ref5 !== void 0 ? ref5 : "0"),
                            allowMultiplePurchase: (ref6 = ticketModalData === null || ticketModalData === void 0 ? void 0 : ticketModalData.allowMultiplePurchase) !== null && ref6 !== void 0 ? ref6 : true
                        };
                        var ref7;
                        const payload = [
                            ...(ref7 = formData === null || formData === void 0 ? void 0 : formData.tickets) !== null && ref7 !== void 0 ? ref7 : []
                        ];
                        if ((ticketModalData === null || ticketModalData === void 0 ? void 0 : ticketModalData.editIndex) || (ticketModalData === null || ticketModalData === void 0 ? void 0 : ticketModalData.editIndex) === 0) payload[ticketModalData.editIndex] = ticketData;
                        else payload.push(ticketData);
                        setFormData({
                            ...formData,
                            tickets: payload
                        });
                        setShowTicketModal(false);
                        setTicketModalData(undefined);
                    }
                })
            })
        ]
    });
    // useEffect(() => {
    //   console.log({ discounts })
    // }, [discounts])
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            addTicketModal,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_registrationFields__WEBPACK_IMPORTED_MODULE_15__["default"], {
                show: showFieldModal,
                setShow: setShowFieldModal,
                initialData: fieldModalData
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_discounts__WEBPACK_IMPORTED_MODULE_16__["default"], {
                show: showDiscountModal,
                setShow: setShowDiscountModal,
                initialData: discountModalData,
                tickets: tickets
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_discounts__WEBPACK_IMPORTED_MODULE_16__.DiscountLinkModal, {
                show: showLinkModal,
                setShow: setShowLinkModal
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_base_Box__WEBPACK_IMPORTED_MODULE_1__["default"], {
                className: "w-full",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_base_Box__WEBPACK_IMPORTED_MODULE_1__["default"], {
                        className: "flex items-center space-x-2 mb-4 mt-6",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_Box__WEBPACK_IMPORTED_MODULE_1__["default"], {
                                className: "text-xl",
                                children: "Tickets List"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_inputs_Button__WEBPACK_IMPORTED_MODULE_2__/* .Button */ .z, {
                                onClick: ()=>{
                                    setTicketModalData(undefined);
                                    setShowTicketModal(true);
                                },
                                title: "Add Ticket",
                                type: "secondary",
                                size: "small"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_Table__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                        tableHeading: [
                            "Title",
                            "Ticket Type",
                            "Price",
                            "Quantity",
                            "Available",
                            ""
                        ],
                        sortable: true,
                        onSort: (d)=>{
                            const payload = {
                                ...formData,
                                tickets: d.map((m)=>{
                                    try {
                                        delete m.remaining;
                                    } catch (_) {}
                                    return m;
                                })
                            };
                            setFormData(payload);
                        },
                        items: tickets,
                        rows: tickets.map((ticket, index)=>{
                            return [
                                ticket.title,
                                ticket.ticketType,
                                "".concat(currencyDetails.symbol).concat(ticket.price.toFixed(2)),
                                ticket.quantity,
                                !!(ticket === null || ticket === void 0 ? void 0 : ticket.remaining) || ticket.remaining === 0 ? ticket.remaining : "N/A",
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_event_TableRowActions__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                                    editClicked: ()=>{
                                        setTicketModalData({
                                            title: ticket.title,
                                            ticketType: ticket.ticketType,
                                            quantity: ticket.quantity,
                                            price: ticket.price,
                                            allowMultiplePurchase: ticket.allowMultiplePurchase,
                                            editIndex: index
                                        });
                                        setShowTicketModal(true);
                                    },
                                    deleteClicked: ()=>{
                                        var ref;
                                        setFormData({
                                            ...formData,
                                            tickets: formData === null || formData === void 0 ? void 0 : (ref = formData.tickets) === null || ref === void 0 ? void 0 : ref.filter((_, i)=>i !== index)
                                        });
                                    }
                                }, index)
                            ];
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_Box__WEBPACK_IMPORTED_MODULE_1__["default"], {
                        show: noTickets,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_Box__WEBPACK_IMPORTED_MODULE_1__["default"], {
                            className: "text-sm mt-8 text-center mb-8",
                            children: "No tickets have been created yet"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_base_Box__WEBPACK_IMPORTED_MODULE_1__["default"], {
                        show: hasPaidTickets && !stripePaymentsReady,
                        className: "mt-4 rounded-lg border border-forumm-orange bg-forumm-orange/10 p-4 text-sm",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_Box__WEBPACK_IMPORTED_MODULE_1__["default"], {
                                className: "font-semibold",
                                children: "Stripe Connect is required"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_base_Box__WEBPACK_IMPORTED_MODULE_1__["default"], {
                                className: "mt-1",
                                children: [
                                    "Paid tickets cannot be published until Stripe is linked and ready in organisation settings.",
                                    stripeStatusLoading ? " Checking your current status..." : ""
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_base_Box__WEBPACK_IMPORTED_MODULE_1__["default"], {
                        className: "flex items-center space-x-2 mt-12",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_Box__WEBPACK_IMPORTED_MODULE_1__["default"], {
                                className: "text-xl",
                                children: "Discount Codes"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_inputs_Button__WEBPACK_IMPORTED_MODULE_2__/* .Button */ .z, {
                                onClick: ()=>{
                                    setDiscountModalData(undefined);
                                    setShowDiscountModal(true);
                                },
                                title: "Add Discount",
                                type: "secondary",
                                size: "small"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_inputs_Button__WEBPACK_IMPORTED_MODULE_2__/* .Button */ .z, {
                                onClick: ()=>{
                                    setShowLinkModal(true);
                                },
                                title: "Discount Link",
                                type: "secondary",
                                size: "small"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_Box__WEBPACK_IMPORTED_MODULE_1__["default"], {
                        className: "mt-4 mb-4 text-sm",
                        children: "Want to provide discounts to your attendees? Create a discount code and assign it to a ticket."
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_Table__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                        tableHeading: [
                            "Name",
                            "Type",
                            "Quantity",
                            "Remaining",
                            "Percentage",
                            "Tickets",
                            ""
                        ],
                        sortable: true,
                        items: discounts,
                        onSort: (d)=>{
                            const payload = {
                                ...formData,
                                discounts: d.map((m)=>{
                                    try {
                                        delete m.remaining;
                                    } catch (_) {}
                                    return m;
                                })
                            };
                            setFormData(payload);
                        },
                        rows: discounts === null || discounts === void 0 ? void 0 : discounts.map((discount, index)=>{
                            var ref;
                            var ref1;
                            return [
                                discount.title,
                                discount.type === _graphql_generated_graphql__WEBPACK_IMPORTED_MODULE_7__/* .DiscountType.Percentage */ .Lb.Percentage ? "% Off" : "2-4-1",
                                discount.quantity,
                                discount.remaining,
                                !!discount.percentage ? "".concat(discount.percentage, "%") : "",
                                (ref1 = (ref = discount.tickets) === null || ref === void 0 ? void 0 : ref.join(", ")) !== null && ref1 !== void 0 ? ref1 : "",
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_Box__WEBPACK_IMPORTED_MODULE_1__["default"], {
                                    className: "flex justify-between items-center",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_event_TableRowActions__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                                        confirmModal: {
                                            title: "Are you sure?",
                                            content: "Are you sure you want to delete this? This cannot be undone."
                                        },
                                        editClicked: ()=>{
                                            console.log({
                                                click: index
                                            });
                                            setDiscountModalData({
                                                ...discount,
                                                editIndex: index
                                            });
                                            setShowDiscountModal(true);
                                        },
                                        deleteClicked: ()=>{
                                            console.log({
                                                click: index
                                            });
                                            setFormData({
                                                ...formData,
                                                discounts: discounts === null || discounts === void 0 ? void 0 : discounts.filter((_, i)=>i !== index)
                                            });
                                        }
                                    })
                                }, index)
                            ];
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_base_Box__WEBPACK_IMPORTED_MODULE_1__["default"], {
                        show: noDiscounts,
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_Box__WEBPACK_IMPORTED_MODULE_1__["default"], {
                                className: "text-sm mt-8 text-center mb-8",
                                children: "No discounts have been created"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("hr", {
                                className: "my-6 border-gray-600 opacity-50"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_base_Box__WEBPACK_IMPORTED_MODULE_1__["default"], {
                        className: "flex items-center space-x-2 mt-12",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_Box__WEBPACK_IMPORTED_MODULE_1__["default"], {
                                className: "text-xl",
                                children: "Registration Details"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_inputs_Button__WEBPACK_IMPORTED_MODULE_2__/* .Button */ .z, {
                                onClick: ()=>{
                                    setFieldModalData(undefined);
                                    setShowFieldModal(true);
                                },
                                title: "Add Field",
                                type: "secondary",
                                size: "small"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_Box__WEBPACK_IMPORTED_MODULE_1__["default"], {
                        className: "mt-4 mb-4 text-sm",
                        children: "Need to capture some information from your attendees? Add information fields that you wish to capture from attendees"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_Box__WEBPACK_IMPORTED_MODULE_1__["default"], {
                        className: "my-2 font-bold",
                        children: "All attendees will be asked for their name and email address."
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_Table__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                        tableHeading: [
                            "Field Name",
                            ""
                        ],
                        sortable: true,
                        onSort: (d)=>{
                            const payload = {
                                ...formData,
                                registrationFields: d
                            };
                            setFormData(payload);
                        },
                        items: registrationFields !== null && registrationFields !== void 0 ? registrationFields : [],
                        rows: registrationFields === null || registrationFields === void 0 ? void 0 : registrationFields.map((field, index)=>{
                            return [
                                field.name,
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_base_Box__WEBPACK_IMPORTED_MODULE_1__["default"], {
                                    className: "flex justify-between items-center",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_base_Box__WEBPACK_IMPORTED_MODULE_1__["default"], {
                                            className: "text-sm flex flex-col",
                                            ignoreTheme: true,
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_base_Box__WEBPACK_IMPORTED_MODULE_1__["default"], {
                                                    className: "text-sm",
                                                    ignoreTheme: true,
                                                    children: [
                                                        "Type: ",
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                            className: "text-gray-500 text-xs",
                                                            children: field.options && field.options.length > 0 ? "".concat(field.type, " (").concat(field.options.length, ")") : field.type
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_base_Box__WEBPACK_IMPORTED_MODULE_1__["default"], {
                                                    show: !!field.unique,
                                                    className: "text-sm",
                                                    ignoreTheme: true,
                                                    children: [
                                                        "Unique Answer: ",
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                            className: "text-gray-500 text-xs",
                                                            children: field.unique ? "Yes" : "No"
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_event_TableRowActions__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                                            confirmModal: {
                                                title: "Are you sure?",
                                                content: "Are you sure you want to delete this? This cannot be undone."
                                            },
                                            editClicked: ()=>{
                                                setFieldModalData({
                                                    ...field,
                                                    editIndex: index
                                                });
                                                setShowFieldModal(true);
                                            },
                                            deleteClicked: ()=>{
                                                setFormData({
                                                    ...formData,
                                                    registrationFields: registrationFields === null || registrationFields === void 0 ? void 0 : registrationFields.filter((_, i)=>i !== index)
                                                });
                                            }
                                        })
                                    ]
                                }, index)
                            ];
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_base_Box__WEBPACK_IMPORTED_MODULE_1__["default"], {
                        show: noFields,
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_Box__WEBPACK_IMPORTED_MODULE_1__["default"], {
                                className: "text-sm mt-8 text-center mb-8",
                                children: "No custom fields have been created"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("hr", {
                                className: "my-6 border-gray-600 opacity-50"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
TicketsForm.Layout = _layouts_CreateEventLayout__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z;
/* harmony default export */ __webpack_exports__["default"] = (TicketsForm);


/***/ }),

/***/ 60899:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ RegistrationFieldModal; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./components/base/Box.tsx
var Box = __webpack_require__(51773);
// EXTERNAL MODULE: ./components/base/Modal.tsx
var Modal = __webpack_require__(18860);
// EXTERNAL MODULE: ./components/inputs/Button.tsx
var Button = __webpack_require__(11390);
// EXTERNAL MODULE: ./components/inputs/DropdownInput.tsx
var DropdownInput = __webpack_require__(61993);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-icons/bi/index.esm.js
var index_esm = __webpack_require__(47516);
// EXTERNAL MODULE: ./node_modules/react-icons/ri/index.esm.js
var ri_index_esm = __webpack_require__(79352);
// EXTERNAL MODULE: ./components/inputs/Validations.tsx
var Validations = __webpack_require__(6686);
;// CONCATENATED MODULE: ./components/inputs/InputPicker/OptionsInput.tsx







const defaultOptionsData = [
    {
        label: "",
        value: ""
    }
];
function OptionsInput(param) {
    let { name , value , className , placeholder , testid , required =false , onChange , validations , show  } = param;
    const [optionsData, setOptionsData] = (0,react.useState)(value !== null && value !== void 0 ? value : defaultOptionsData);
    (0,react.useEffect)(()=>{
        changeHandler(optionsData);
    }, [
        optionsData
    ]);
    (0,react.useEffect)(()=>{
        setOptionsData(value !== null && value !== void 0 ? value : defaultOptionsData);
    }, [
        value
    ]);
    const changeHandler = (opts)=>{
        const isInvalid = (0,Validations/* validate */.G)(opts, validations) !== "";
        onChange && onChange(opts, isInvalid);
    };
    const input = (val, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
            "data-testid": testid ? "".concat(testid, "-").concat(val) : null,
            value: val,
            onChange: (e)=>{
                setOptionsData((state)=>state.map((option, i)=>i === index ? {
                            label: e.target.value,
                            value: e.target.value
                        } : option));
            },
            type: "text",
            placeholder: placeholder,
            id: "".concat(name, "-").concat(val.replaceAll(" ", "").toLowerCase()),
            className: "transition-all bg-transparent rounded px-4 py-4 text-sm outline-none placeholder-gray-500 flex-3"
        });
    if (!show) return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            optionsData === null || optionsData === void 0 ? void 0 : optionsData.map((option, index)=>{
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                        className: [
                            "flex flex-col my-1 rounded border justify-center",
                            className
                        ].join(" "),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                            className: "flex justify-between h-full",
                            children: [
                                input(option.value, index),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                    className: "flex justify-end flex-1 items-center pr-2",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                        type: "square",
                                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(ri_index_esm/* RiDeleteBinLine */.qy0, {
                                            size: 20
                                        }),
                                        className: "mr-2 border-none",
                                        onClick: ()=>setOptionsData((state)=>state.filter((_, i)=>i !== index))
                                    })
                                })
                            ]
                        })
                    })
                }, index);
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                type: "square",
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* BiListPlus */.gnI, {
                    size: 32
                }),
                className: "self-start border-none !pl-3 mt-3",
                onClick: ()=>setOptionsData((state)=>[
                            ...state !== null && state !== void 0 ? state : [],
                            {
                                label: "",
                                value: ""
                            }
                        ])
            })
        ]
    });
}

// EXTERNAL MODULE: ./components/inputs/TextInput.tsx
var TextInput = __webpack_require__(39618);
// EXTERNAL MODULE: ./components/inputs/ToggleInput.tsx
var ToggleInput = __webpack_require__(20970);
// EXTERNAL MODULE: ./graphql/__generated/graphql.ts
var graphql = __webpack_require__(68240);
// EXTERNAL MODULE: ./libs/CreateEvent/useEventEditor.tsx + 6 modules
var useEventEditor = __webpack_require__(25687);
;// CONCATENATED MODULE: ./pages/create-event/registration/registrationFields.tsx











function RegistrationFieldModal(param) {
    let { show , setShow , initialData  } = param;
    const { formData , setFormData  } = (0,useEventEditor/* useEventEditor */.O)();
    const [fieldModalData, setFieldModalData] = (0,react.useState)(initialData);
    (0,react.useEffect)(()=>{
        setFieldModalData(initialData);
    }, [
        initialData
    ]);
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* default */.Z, {
        show: show,
        setShow: setShow,
        title: "".concat((fieldModalData === null || fieldModalData === void 0 ? void 0 : fieldModalData.editIndex) !== undefined ? "Edit" : "Create", " Field"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                className: "flex justify-between items-center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownInput/* DropdownInput */.f, {
                        className: "my-4 mt-4 mr-2",
                        label: "Answer Type",
                        placeholder: "Select a answer type",
                        options: [
                            {
                                label: "Text",
                                value: graphql/* FormInputType.Text */.Tx.Text
                            },
                            {
                                label: "Dropdown",
                                value: graphql/* FormInputType.Dropdown */.Tx.Dropdown
                            },
                            {
                                label: "Number",
                                value: graphql/* FormInputType.Number */.Tx.Number
                            },
                            {
                                label: "Date/Time",
                                value: graphql/* FormInputType.Date */.Tx.Date
                            },
                            {
                                label: "Yes/No",
                                value: graphql/* FormInputType.Bool */.Tx.Bool
                            },
                            {
                                label: "Checkbox",
                                value: graphql/* FormInputType.Checkbox */.Tx.Checkbox
                            }
                        ],
                        onChange: (data)=>{
                            setFieldModalData({
                                ...fieldModalData,
                                type: data,
                                unique: data === graphql/* FormInputType.Text */.Tx.Text ? fieldModalData === null || fieldModalData === void 0 ? void 0 : fieldModalData.unique : false
                            });
                        },
                        value: (ref = fieldModalData === null || fieldModalData === void 0 ? void 0 : fieldModalData.type) !== null && ref !== void 0 ? ref : graphql/* FormInputType.Text */.Tx.Text
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TextInput/* TextInput */.o, {
                        validations: {
                            minLength: {
                                value: 1,
                                message: "Field name must be at least 1 character"
                            },
                            maxLength: {
                                value: 300,
                                message: "Field name must be at most 300 characters"
                            }
                        },
                        required: true,
                        label: "Registration Field",
                        placeholder: "E.g. Year of Graduation",
                        value: fieldModalData === null || fieldModalData === void 0 ? void 0 : fieldModalData.name,
                        onChange: (data)=>{
                            setFieldModalData({
                                ...fieldModalData,
                                name: data
                            });
                        },
                        className: "flex-1"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ToggleInput/* ToggleInput */.s, {
                errorMessage: undefined,
                selected: (fieldModalData === null || fieldModalData === void 0 ? void 0 : fieldModalData.visibleOnAttendeeList) ? 0 : 1,
                centerText: true,
                options: [
                    "Yes",
                    "No"
                ],
                className: "mb-4",
                value: (fieldModalData === null || fieldModalData === void 0 ? void 0 : fieldModalData.visibleOnAttendeeList) ? "Yes" : "No",
                callback: (data)=>{
                    setFieldModalData({
                        ...fieldModalData,
                        visibleOnAttendeeList: data === "Yes" ? true : false
                    });
                },
                label: "Data to be shared to Attendee List"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ToggleInput/* ToggleInput */.s, {
                errorMessage: undefined,
                show: !!(fieldModalData === null || fieldModalData === void 0 ? void 0 : fieldModalData.type) && fieldModalData.type === graphql/* FormInputType.Text */.Tx.Text,
                selected: (fieldModalData === null || fieldModalData === void 0 ? void 0 : fieldModalData.unique) ? 0 : 1,
                centerText: true,
                options: [
                    "Yes",
                    "No"
                ],
                className: "mb-4",
                value: (fieldModalData === null || fieldModalData === void 0 ? void 0 : fieldModalData.unique) ? "Yes" : "No",
                callback: (data)=>{
                    setFieldModalData({
                        ...fieldModalData,
                        unique: data === "Yes" ? true : false
                    });
                },
                label: "Unique Answer Required?"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ToggleInput/* ToggleInput */.s, {
                errorMessage: undefined,
                selected: (fieldModalData === null || fieldModalData === void 0 ? void 0 : fieldModalData.required) ? 0 : 1,
                centerText: true,
                options: [
                    "Yes",
                    "No"
                ],
                className: "mb-4",
                value: (fieldModalData === null || fieldModalData === void 0 ? void 0 : fieldModalData.required) ? "Yes" : "No",
                callback: (data)=>{
                    setFieldModalData({
                        ...fieldModalData,
                        required: data === "Yes" ? true : false
                    });
                },
                label: "Answer Required?"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ToggleInput/* ToggleInput */.s, {
                errorMessage: undefined,
                show: !!(fieldModalData === null || fieldModalData === void 0 ? void 0 : fieldModalData.type) && fieldModalData.type === graphql/* FormInputType.Date */.Tx.Date,
                selected: (fieldModalData === null || fieldModalData === void 0 ? void 0 : fieldModalData.dateOnly) ? 0 : 1,
                centerText: true,
                options: [
                    "Date Only",
                    "Date & Time"
                ],
                className: "mb-4",
                value: (fieldModalData === null || fieldModalData === void 0 ? void 0 : fieldModalData.dateOnly) ? "Date Only" : "Date & Time",
                callback: (data)=>{
                    setFieldModalData({
                        ...fieldModalData,
                        dateOnly: data === "Date Only" ? true : false
                    });
                },
                label: "Date Options"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(OptionsInput, {
                name: "",
                value: fieldModalData === null || fieldModalData === void 0 ? void 0 : fieldModalData.options,
                show: !!(fieldModalData === null || fieldModalData === void 0 ? void 0 : fieldModalData.type) && fieldModalData.type === graphql/* FormInputType.Dropdown */.Tx.Dropdown,
                required: !!(fieldModalData === null || fieldModalData === void 0 ? void 0 : fieldModalData.type) && fieldModalData.type === graphql/* FormInputType.Dropdown */.Tx.Dropdown,
                onChange: (data)=>{
                    setFieldModalData({
                        ...fieldModalData,
                        options: data
                    });
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                className: "my-4",
                title: "".concat((fieldModalData === null || fieldModalData === void 0 ? void 0 : fieldModalData.editIndex) !== undefined || (fieldModalData === null || fieldModalData === void 0 ? void 0 : fieldModalData.editIndex) === 0 ? "Save" : "Create", " Field"),
                type: "primary",
                onClick: (e)=>{
                    var ref;
                    e.preventDefault();
                    if (!(fieldModalData === null || fieldModalData === void 0 ? void 0 : fieldModalData.name)) return;
                    var ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8;
                    const fieldData = {
                        name: fieldModalData === null || fieldModalData === void 0 ? void 0 : fieldModalData.name,
                        unique: (ref1 = fieldModalData === null || fieldModalData === void 0 ? void 0 : fieldModalData.unique) !== null && ref1 !== void 0 ? ref1 : false,
                        dateOnly: (ref2 = fieldModalData === null || fieldModalData === void 0 ? void 0 : fieldModalData.dateOnly) !== null && ref2 !== void 0 ? ref2 : false,
                        required: (ref3 = fieldModalData === null || fieldModalData === void 0 ? void 0 : fieldModalData.required) !== null && ref3 !== void 0 ? ref3 : false,
                        visibleOnAttendeeList: (ref4 = fieldModalData === null || fieldModalData === void 0 ? void 0 : fieldModalData.visibleOnAttendeeList) !== null && ref4 !== void 0 ? ref4 : false,
                        type: (ref5 = fieldModalData === null || fieldModalData === void 0 ? void 0 : fieldModalData.type) !== null && ref5 !== void 0 ? ref5 : graphql/* FormInputType.Text */.Tx.Text,
                        ...{
                            options: (ref8 = fieldModalData === null || fieldModalData === void 0 ? void 0 : (ref = fieldModalData.options) === null || ref === void 0 ? void 0 : ref.map((o)=>{
                                return {
                                    label: (ref6 = o === null || o === void 0 ? void 0 : o.label) !== null && ref6 !== void 0 ? ref6 : o,
                                    value: (ref7 = o === null || o === void 0 ? void 0 : o.value) !== null && ref7 !== void 0 ? ref7 : o
                                };
                            })) !== null && ref8 !== void 0 ? ref8 : []
                        }
                    };
                    var ref9;
                    const payload = [
                        ...(ref9 = formData === null || formData === void 0 ? void 0 : formData.registrationFields) !== null && ref9 !== void 0 ? ref9 : []
                    ];
                    if ((fieldModalData === null || fieldModalData === void 0 ? void 0 : fieldModalData.editIndex) === 0 || (fieldModalData === null || fieldModalData === void 0 ? void 0 : fieldModalData.editIndex)) payload[fieldModalData.editIndex] = fieldData;
                    else payload.push(fieldData);
                    setFormData({
                        ...formData,
                        registrationFields: payload
                    });
                    setShow(false);
                    setFieldModalData({
                        ...fieldModalData,
                        name: ""
                    });
                }
            })
        ]
    });
}


/***/ })

}]);